export default __webpack_public_path__ + "static/media/account-settings-page.adba3891.png";